import { useBreakpoints as _useBreakpoints } from "@vueuse/core";
const breakpoints = {
  sm: "40rem",
  md: "48rem",
  lg: "64rem",
  xl: "80rem",
  xxl: "96rem",
} as const;

export function useBreakpoints() {
  return _useBreakpoints(breakpoints);
}

export function useIsMobile() {
  const { smaller } = useBreakpoints();
  // SSR has no width in context by default so checking smaller will result in
  // false, which is the more likely scenario. If user agents were inspected a
  // safer alternative is greaterOrEqual('md')
  return smaller("md");
}
